import { render, staticRenderFns } from "./InsuranceRiskPayment.vue?vue&type=template&id=18118f92&"
import script from "./InsuranceRiskPayment.vue?vue&type=script&lang=js&"
export * from "./InsuranceRiskPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports